import { z } from 'zod';

// Additional Information Validation Schema
export const additionalInformationSchema = z.object({
  role: z.string().trim().optional(),
  addressLine1: z.string().trim().optional().nullable(),
  addressLine2: z.string().trim().optional().nullable(),
  townCity: z.string().trim().optional().nullable(),
  countyDistrict: z.string().trim().optional().nullable(),
  postcode: z.string().trim().optional().nullable(),
});

export type AdditionalInformationFormValues = z.infer<typeof additionalInformationSchema>;
